import React from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { placeholderResourceText } from "../../shared/helpers/placeHolders";
import { IField } from "../../shared/model/field.model";
import { labelResponse } from "../../shared/helpers/labels";
import { IOption } from "../../shared/model/option.model";
interface IProps {
  formik: any;
  field: IField;
  indexField: number;
  errors: number[];
}
export const InputText = (props: IProps) => {
  const { field, formik, indexField } = props;
  return (
    <FormGroup>
      <Label>
        <h4>{field.name}</h4>
        <h5>{field.description}</h5>
        <p className="pt-3">{labelResponse()}</p>
      </Label>
      {field.options &&
        field.options.map((option: IOption, indOp: number) => (
          <div key={indOp}>
            <Input
              name={`resourceToInstance.resource.fields[${indexField}].options[${indOp}].response`}
              type="textarea"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={
                formik.values?.resourceToInstance?.resource?.fields[indexField]
                  ?.options[indOp]?.response || ""
              }
              className={`form-control text-area-resource`}
              placeholder={placeholderResourceText()}
            />
          </div>
        ))}
      {props.errors.length > 0 &&
        field?.id &&
        props.errors.indexOf(field.id) >= 0 && (
          <div className="invalid-field">Este campo es obligatorio</div>
        )}
    </FormGroup>
  );
};
